export const styles = {
    floatingText: {
        display: 'flex',
        color: '#1e293b',
        fontFamily: "'Inter', sans-serif",
      },
      label: {
        display: 'flex',
        fontSize: '14px',
        color: '#64748b',
        fontFamily: "'Inter', sans-serif",
      },
      error: {
        fontSize: '12px',
        color: '#dc2626',
        fontWeight: '500',
        fontFamily: "'Inter', sans-serif",
      },
      floatingLabelStyle: {
        fontSize: '14px',
        display: 'flex',
        color: '#1e293b',
        fontFamily: "'Inter', sans-serif",
      },
      hintStyle: {
        fontSize: '5px'
      },
      reportTable_tab: {
        margin: '0px',
        color: '#1e293b',
        borderBottom: '1px solid #e2e8f0',
        borderRight: '1px solid #e2e8f0',
        fontFamily: "'Inter', sans-serif",
      },
      inkBarStyle: {
        border: '2px solid #2563eb'
      },
      tabItemContainerStyle: {
        backgroundColor: '#ffffff'
      },
      reportTable_tabs: {
        clear: 'both',
        border: '1px solid #e2e8f0',
        margin: '10px',
        borderRadius: '8px',
        overflow: 'hidden',
      }
}
export const ITEM_HEIGHT = 48;

export const ITEM_PADDING_TOP = 8;

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const MenuPropsMaxHeight = {
  PaperProps: {
    style: {
      width: 300,
    },
  },
};

const drawerWidth = 300;

export const drawerStyles = {
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: '0 8px',
      justifyContent: 'flex-end',
    },
    root: {
      flexGrow: 1,
    },
    grow: {
      flexGrow: 1,
    },
    menuButton: {
      marginLeft: -12,
      marginRight: 20,
    },
    logo: {
      textDecoration: 'none',
      color: '#e2e8f0',
      fontFamily: "'Inter', sans-serif",
      fontWeight: 600,
    }
}

export const mandatoryFieldLabelProps = {
  color: 'red',
  marginLeft: '-7px',
  fontSize: '20px'
}


// WEBPACK FOOTER //
// ./src/materialUIStyles.js